<template>
  <div class="layout-segment">
    <a-row>
      <a-col :sm="24" :md="17">
        <div class="rodo-clause font-14">
          <p>
            <strong
              >Przeczytaj klauzulę informacyjną i dowiedz się, na jakich
              zasadach będziemy przetwarzać Twoje dane osobowe. Klikając
              przycisk „Zamówienie wstępne”, potwierdzasz, że zapoznałeś/aś się
              z tymi zasadami.</strong
            >
          </p>
          <p>
            <strong>KLAUZULA INFORMACYJNA</strong><br />
            ADMINISTRATOR DANYCH OSOBOWYCH<br />
            Administratorem podanych przez Ciebie danych osobowych na etapie
            poszukiwania imprezy turystycznej jest Travelplanet.pl S.A.
            z&nbsp;siedzibą we Wrocławiu, kod pocztowy 54-202, ul. Legnicka 48-50 bud.G.
            W związku z zawarciem i realizacją umowy...
          </p>
          <span class="rodo-clause__more rodo--clause--more"
            >Czytaj całość</span
          >
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
export default {
  data: () => ({
    x: 1
  }),
  mounted() {
    bindRodoButton();
  }
};

function openrodo(src, myWidth, myHeight) {
  var w =
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth;
  var h =
    window.innerHeight ||
    document.documentElement.clientHeight ||
    document.body.clientHeight;
  if (w > 800) {
    myWidth = w - 200;
  }
  if (h > 600) {
    myHeight = h - 200;
  }
  window.open(
    src,
    "TravelOne.pl",
    "top=200,left=100,toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=no,resizable=no,fullscreen=no,channelmode=no,width=" +
      myWidth +
      ",height=" +
      myHeight
  );
}

function bindRodoButton() {
  jQuery(".rodo--clause--more").click(function(e) {
    openrodo("/warunki/klauzula_inf.pdf", 600, 400);
  });
}
</script>

<style lang="scss" scoped>
@import "@/scss/_components/_T1RODO";
</style>
